/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import AppointmentAction from 'DesignSystem/AppointmentAction/index'
import MissingRequiredTreatmentFieldsDialog from './MissingRequiredTreatmentFieldsDialog/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/AppointmentActions/Unseat/Content",
  onSubmit
  
}) {
let unseatSubmitData = fromData.useDataSubmit({ viewPath,
context: 'unseat',
})
  return (<React.Fragment
>
<AppointmentAction
  viewPath={`${viewPath}/AppointmentAction`}
 text="Unseat"
 data="unseat"
 onClick={unseatSubmitData}
/>
<MissingRequiredTreatmentFieldsDialog
  viewPath={`${viewPath}/MissingRequiredTreatmentFieldsDialog`}
/>
{children}
</React.Fragment>)
}